module.exports = __webpack_public_path__ + "static/img/3.9d27e9ee.jpg";